/**
 * Created by Ning Jiang on 2/21/2020.
 */

import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {DeadwoodGameConfig} from "../../DeadwoodGameConfig";
import {TweenLite} from "gsap";

export class BonusReelNearWinView extends BaseView {

    private _layer:ScalableLayer;
    private _nearWinSprite:PIXI.Sprite;
    private _nearWinSpine:PIXI.spine.Spine;

    private _currentReelId:number;
    private _isPlaying:boolean;

    constructor() {
        super();

        this.reset();
    }

    protected initAnimations():void {
        this._layer = StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.NEAR_WIN.name);

        this._nearWinSprite = new PIXI.Sprite();
        this._nearWinSprite.anchor.set(0.5);
        this._nearWinSprite.alpha = 0;
        this._layer.addChild(this._nearWinSprite);

        this._nearWinSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("nearWin_shootOut"));
        this._nearWinSpine.autoUpdate = true;
        this._nearWinSprite.addChild(this._nearWinSpine);

        const mask:PIXI.Graphics = new PIXI.Graphics();
        mask.beginFill(0x00ff00);
        mask.drawRect(GameConfig.instance.REEL_AREA_POS_X, DeadwoodGameConfig.instance.REEL_AREA_TOP, GameConfig.instance.REEL_AREA_WIDTH, DeadwoodGameConfig.instance.REEL_AREA_ACTUAL_HEIGHT);
        mask.endFill();
        this._layer.addChild(mask);
        this._nearWinSprite.mask = mask;
    }

    public playBonusNearWin(reelId:number):void {
        this._currentReelId = reelId;
        this._isPlaying = true;
        const positionX:number = GameConfig.instance.REEL_DISPLAY_POSITIONS[reelId][0] + GameConfig.instance.REEL_AREA_POS_X;
        const positionY:number = GameConfig.instance.REEL_DISPLAY_POSITIONS[2][1] + GameConfig.instance.SYMBOL_HEIGHT * 2;
        this._nearWinSprite.position.set(positionX, positionY);
        this._nearWinSpine.state.clearTrack(0);
        this._nearWinSpine.skeleton.setToSetupPose();
        new SpineTween(this._nearWinSpine, 0, "animation", -1);
        TweenLite.to(this._nearWinSprite, 0.2, {alpha: 1});
    }

    public stopNearWin(reelId:number):void {
        if(reelId != this._currentReelId) {
            debugger;
            throw new Error(`BonusReelNearWinView.stopNearWin(): try to stop reel ${reelId} when current id is ${this._currentReelId}`);
        }
        this._isPlaying = false;
        TweenLite.to(this._nearWinSprite, 0.3, {alpha : 0, onComplete : () => this.stopAllAnimations()});
    }

    private stopAllAnimations():void {
        this._nearWinSpine.state.setEmptyAnimation(0, 0);
    }

    public reset():void {
        this._currentReelId = -1;
    }
}